import React from 'react';
import Uganda_s3 from './uganda_s3';
import Uganda_s3_subjects from './uganda_s3_subjects';
const Uganda_s3per = () => {
  return (
    <div>
      <Uganda_s3 />
    <Uganda_s3_subjects />
    <div className='relative right-0 left-0 top-37 '>
      <h1>PERFORMING ARTS</h1>
      <h3>Performing arts in the new secondary school curriculum</h3>
      <li>Generic skills or Soft skills or 21st century skills integrated in PA learning and assessment </li>
      <li>Cross-cutting isues integrated in PA learning and assessment </li>
      <li>Values integrated in PA learning and assessment </li>
      </div>
    </div>
  );
}

export default Uganda_s3per;